import { ComponentProps } from 'react';
import { Button } from '../../../../../design-system/button/button';
import { Stack } from '../../../../../design-system/stack/stack';
import { InvoiceCard } from '../invoice-card';

type MarkNotPaidModalContentProps = {
  invoiceInfo: ComponentProps<typeof InvoiceCard>;
  isLoading: boolean;
  onMarkNotPaid: () => Promise<void>;
};

export const MarkNotPaidModalContent = ({ invoiceInfo, isLoading, onMarkNotPaid }: MarkNotPaidModalContentProps) => {
  return (
    <Stack space={10} align="stretch">
      <Stack space={4} align="stretch">
        <Stack space={4} align="stretch">
          <h1 className="text-xl font-medium leading-6 tracking-tight text-black">Mark as not paid</h1>

          <p className="text-base font-medium leading-6 tracking-tight text-seapoint-gray-text">
            This will mark this invoice as requires payment for your approval and payment
          </p>
        </Stack>

        <InvoiceCard {...invoiceInfo} />
      </Stack>

      <Button variant="destructive" isLoading={isLoading} onClick={onMarkNotPaid}>
        Mark as not paid
      </Button>
    </Stack>
  );
};
